import "./style.scss";
import HorizontalNavbar from "./components/navbar/HorizontalNavbar";
import AllEntity from "./pages/all/allEntity/AllEntity";
import AllEntityHome from "./pages/all/allEntityHome/AllEntityHome";
import EntityImport from "./pages/all/entityImport/EntityImport";
import Login from "./pages/login/Login";
import UwPolicy from "./pages/uw/uwPolicy/UwPolicy";
import UwRegister from "./pages/uw/uwRegister/UwRegister";
import UwRenewal from "./pages/uw/uwRenewal/UwRenewal";
import { setSessionValidated } from "./redux/userSlice";
import { useEffect } from "react";
import {
  createBrowserRouter,
  Link,
  Navigate,
  Outlet,
  RouterProvider
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TermsAndConditions from "./components/termsAndConditions/TermsAndConditions";
import ApPayment from "./pages/ap/apPayment/ApPayment";
import ApPaymentHome from "./pages/ap/apPaymentHome/ApPaymentHome";
import ArHome from "./pages/ar/ArHome";
import ArReceipt from "./pages/ar/arReceipt/ArReceipt";
import ArReceiptHome from "./pages/ar/arReceiptHome/ArReceiptHome";
import CmClaim from "./pages/cm/cmClaim/CmClaim";
import CmHome from "./pages/cm/cmHome/CmHome";
import GlHome from "./pages/gl/GlHome";
import Register from "./pages/register/Register";
import AllValueSet from "./pages/all/allValueSet/AllValueSet";
import UwProduct from "./pages/uw/uwProduct/UwProduct";
import UwSubClass from "./pages/uw/uwSubClass/UwSubClass";
import ValidateSignup from "./pages/validateSignup/ValidateSignup";
import AllEntityCatg from "./pages/all/allEntityCatg/AllEntityCatg";
import UwVehicleImport from "./pages/uw/uwVehicleImport/UwVehicleImport";
import SearchResults from "./pages/all/searchResults/SearchResults";
import Todo from "./pages/all/todo/Todo";
import UwPolicyNew from "./pages/uw/uwPolicyNew/UwPolicyNew";
import LandingPage from "./pages/landingPage/LandingPage";
import AdProfile from "./pages/ad/adProfile/AdProfile";
import VerifyDocument from "./pages/verifyDocument/VerifyDocument";
import AllEntityCentral from "./pages/all/allEntityCentral/AllEntityCentral";
import VerticalNavbar from "./components/navbar/VerticalNavbar";
import MainHome from "./pages/mainHome/MainHome";
import AdCompany from "./pages/ad/adCompany/AdCompany";
import ApDb from "./pages/ap/apDb/ApDb";
import GlCurrency from "./pages/gl/glCurrency/GlCurrency";
import GlCalendar from "./pages/gl/glCalendar/GlCalendar";
import AdSysCode from "./pages/ad/adSysCode/AdSysCode";
import ArDb from "./pages/ar/arDb/ArDb";
import CmClaimList from "./pages/cm/cmClaimList/CmClaimList";
import CmDb from "./pages/cm/cmDb/CmDb";
import AdControl from "./pages/ad/adControl/AdControl";
import AdSubscription from "./pages/ad/adSubscription/AdSubscription";
import AdUser from "./pages/ad/adUser/AdUser";
import EmailTemplate from "./pages/all/emailTemplate/EmailTemplate";
import UwProductHome from "./pages/uw/uwProductHome/UwProductHome";
import AllFilesList from "./components/allFIlesList/AllFilesList";
import UwPolicyList from "./pages/uw/uwPolicyList/UwPolicyList";
import UwCommRates from "./pages/uw/uwCommRates/UwCommRates";
import GlStatement from "./pages/gl/glStatement/GlStatement";
import UwDb from "./pages/uw/uwDb/UwDb";
import UwMortalityRates from "./pages/uw/uwMortalityRates/UwMortalityRates";
import UwMedicalReview from "./pages/uw/uwMedicalReview/UwMedicalReview";
import UwMedicalRequest from "./pages/uw/uwMedicalRequest/UwMedicalRequest";
import UwMedicalSingle from "./pages/uw/uwMedicalSingle/UwMedicalSingle";
import AllNumberGen from "./pages/all/allNumberGen/AllNumberGen";
import UploadChat from "./pages/uploadChat/UploadChat";
import GlBank from "./pages/gl/glBank/GlBank";
import NotFoundPage from "./pages/notFoundPage/NotFoundPage";
import AllReportRun from "./pages/all/allReportRun/AllReportRun";
import GlPeriodBalance from "./pages/gl/glPeriodBalance/GlPeriodBalance";
import UwPivotTable from "./components/uwPivotTable/UwPivotTable";
import GlBankAc from "./pages/gl/glBankAc/GlBankAc";
import GlCoa from "./pages/gl/glCoa/GlCoa";
import GlIntegration from "./pages/gl/glIntegration/GlIntegration";
import AllLocation from "./pages/all/allLocation/AllLocation";
import AllPlans from "./pages/all/allPlans/AllPlans";
import MainHomeEntity from "./pages/mainHome/MainHomeEntity";
import FacilityClaimsList from "./pages/facility/facilityClaimsList/FacilityClaimsList";
import FacilityClaim from "./pages/facility/facilityClaim/FacilityClaim";
import FacilityReports from "./pages/facility/facilityReports/FacilityReports";
import FacilityPayments from "./pages/facility/facilityPayments/FacilityPayments";
import GlContributionHome from "./pages/gl/glContributionHome/GlContributionHome";
import GlContribution from "./pages/gl/glContribution/GlContribution";
import FacilityClaimInbox from "./pages/facility/facilityClaimInbox/FacilityClaimInbox";
import GlTransactions from "./pages/gl/glTransactions/GlTransactions";
import RiTreaty from "./pages/ri/riTreaty/RiTreaty";
import RiBatches from "./pages/ri/riBatches/RiBatches";
import RiBatch from "./pages/ri/riBatch/RiBatch";
import TestPage from "./pages/testPage/TestPage";
import GlPlanList from "./pages/gl/glPlanList/GlPlanList";
import GlPlanSingle from "./pages/gl/glPlanSingle/GlPlanSingle";
import BdHomeList from "./pages/bd/bdHomeList/BdHomeList";
import JobsList from "./pages/jobs/jobsList/JobsList";
import AmFundHome from "./pages/am/amFundHome/AmFundHome";
import AmFund from "./pages/am/amFund/AmFund";
import AmSecurityHome from "./pages/am/amSecurityHome/AmSecurityHome";
import AmSecurity from "./pages/am/amSecurity/AmSecurity";
import AmSubHome from "./pages/am/amSubHome/AmSubHome";
import AmSub from "./pages/am/amSub/AmSub";
import AmMonitor from "./pages/am/amMonitor/AmMonitor";
import AmBenchmarkHome from "./pages/am/amBenchmarkHome/AmBenchmarkHome";
import AmMonitorHome from "./pages/am/amMonitorHome/AmMonitorHome";
import AmTradeHome from "./pages/am/amTradeHome/AmTradeHome";
import AmTrade from "./pages/am/amTrade/AmTrade";
import OnboardingChecklist from "./components/onboardingChecklist/OnboardingChecklist";
import UwFireImport from "./pages/uw/uwFireImport/UwFireImport";
import AdUsersHome from "./pages/ad/adUsersHome/AdUsersHome";
import { useDispatch, useSelector } from "react-redux";
import { initSocket, closeSocket } from "./redux/socketManager";
import { setConnected, setDisconnected } from "./redux/socketSlice";
import { store } from "./redux/store";
import UwSubAgent from "./pages/uw/uwSubAgent/UwSubAgent";
import AdConfig from "./pages/ad/adConfig/AdConfig";
import HrJob from "./pages/hr/hrJob/HrJob";
import HrAbsence from "./pages/hr/hrAbsence/HrAbsence";
import HrPosition from "./pages/hr/hrPosition/HrPosition";
import HrPeople from "./pages/hr/hrPeople/HrPeople";
import AllNotificationGroup from "./pages/all/allNotificationGroup/AllNotificationGroup";
import UwDmvicCerts from "./pages/uw/uwDmvicCerts/UwDmvicCerts";
import TicketCategory from "./pages/tk/ticketCategory/TicketCategory";
import TicketAlerts from "./pages/tk/ticketAlerts/TicketAlerts";
import Tickets from "./pages/tk/tickets/Tickets";
import Ticket from "./pages/tk/ticket/Ticket";
import AdAuctions from "./pages/ad/adAuctions/AdAuctions";
import AdAuction from "./pages/ad/adAuction/AdAuction";
import UwRiskMap from "./pages/uw/uwRiskMap/UwRiskMap";
import AdScan from "./pages/ad/adScan/AdScan";
import BotChat from "./pages/botChat/BotChat";
import AllReportGroup from "./pages/all/allReportGroup/AllReportGroup";
import GlJournalHome from "./pages/gl/glJournalHome/GlJournalHome";
import GlJournal from "./pages/gl/glJournal/GlJournal";
import OnlineUsers from "./components/onlineUsers/OnlineUsers";
import AgendaJobs from "./pages/all/agendaJobs/AgendaJobs";


function App() {
  const { currentUser, sessionValidated } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const dispatch = useDispatch();

  useEffect(() => {
    initSocket(dispatch, store.getState);

    return () => {
      closeSocket();
      dispatch(setDisconnected());
    };
  }, [dispatch]);

  useEffect(() => {
    if (currentUser) {
      dispatch(setSessionValidated(true));
    }
  }, [currentUser, dispatch]);

  // Public Layout for non-protected routes
  const PublicLayout = () => (
    <div className="public-container">
      {/* <div>This is public</div> */}
      <Outlet />
      {/* <Footer /> */}
    </div>
  );

  // Protected Layout for protected routes
  const ProtectedLayout = () => (
    <div className="private-container">
      {/* hide vertical toolbar for users with entity */}
      {/* {currentUser?.usr_entity_code ? <></> : <VerticalNavbar />} */}
      <VerticalNavbar />
      <div style={{
        display: "flex",
        width: "100%",
        height: "100%",
        flexDirection: "column",
        flex: "1 1 auto",
        overflowX: "hidden",
        flexGrow: "1",
        gap: "5px"
      }}>
        <HorizontalNavbar />
        <Outlet />
      </div>
    </div>
  );

  // Redirect logic
  // const RedirectToCorrectLayout = () => {
  //   if (currentUser) {
  //     return <Navigate to="/home" />;
  //   }
  //   // If pendingUser exists, stay on /bima → let confirmDevice render
  //   return <Navigate to="/bima" />;
  // };

  const RedirectToCorrectLayout = () => {
    if (currentUser && sessionValidated) {
      return <Navigate to="/home" replace />;
    }

    return <Navigate to="/bima" replace />;
  };


  // ProtectedRoute wrapper to enforce authentication
  // const ProtectedRoute = ({ children }) => {
  //   return currentUser ? children : <Navigate to="/bima" />;
  // };

  const ProtectedRoute = ({ children }) => {
    const { currentUser, sessionValidated } = useSelector((state) => state.user);

    if (!currentUser || !sessionValidated) {
      return <Navigate to="/bima" replace />;
    }

    return children;
  };


  // Router configuration
  const router = createBrowserRouter([
    {
      path: "/",
      element: <RedirectToCorrectLayout />,
    },
    {
      path: "/",
      element: <PublicLayout />,
      children: [
        {
          path: "/bima",
          element: <LandingPage />,
        },
        {
          path: "/login",
          element: currentUser ? <Navigate to="/" /> : <Login />,
        },
        {
          path: "/register",
          element: <Register />,
        },
        {
          path: "/tac",
          element: <TermsAndConditions />,
        },
        {
          path: "/signup/:id",
          element: <ValidateSignup />,
        },
        {
          path: "/verify/:docType/:docId",
          element: <VerifyDocument />,
        },
        {
          path: "*",
          element: <DefaultErrorPage />
        },
      ],
    },
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <ProtectedLayout />
        </ProtectedRoute>
      ),
      children: [
        {
          path: "/home",
          element: <MainHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/mainHome",
          element: <MainHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/online",
          element: <OnlineUsers />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/ngen",
          element: <AllNumberGen />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/ngrp",
          element: <AllNotificationGroup />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/chat",
          element: <UploadChat />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/clients",
          element: <AllEntityHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/catg",
          element: <AllEntityCatg />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/company",
          element: <AdCompany />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/onboarding",
          element: <OnboardingChecklist />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/payments",
          element: <ApPaymentHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/apDb",
          element: <ApDb />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/receipts",
          element: <ArReceiptHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/arDb",
          element: <ArDb />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/currencies",
          element: <GlCurrency />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/calendars",
          element: <GlCalendar />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/gljv",
          element: <GlJournalHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/journal/:docid",
          element: <GlJournal />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/gltrans",
          element: <GlTransactions />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/lookups",
          element: <AdSysCode />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/claims",
          element: <CmClaimList />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/cmDb",
          element: <CmDb />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/controls",
          element: <AdControl />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/sub",
          element: <AdSubscription />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/files",
          element: <AllFilesList />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/users",
          element: <AdUsersHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/user/:docid",
          element: <AdUser />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/templates",
          element: <EmailTemplate />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/uwsc",
          element: <UwSubClass />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/uwproducts",
          element: <UwProductHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/product/:docid",
          element: <UwProduct />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/docs/:docType",
          element: <UwPolicyList />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/uw/policy/:docid",
          element: <UwPolicy />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/uw/quote/:docid",
          element: <UwPolicy />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/uw/quoterequest/:docid",
          element: <UwPolicy />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/uw/opportunity/:docid",
          element: <UwPolicy />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/uw/risknote/:docid",
          element: <UwPolicy />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/renewals",
          element: <UwRenewal />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/uwreg",
          element: <UwRegister />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/dmvic",
          element: <UwDmvicCerts />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/mortality",
          element: <UwMortalityRates />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/uwDb",
          element: <UwDb />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/subagt",
          element: <UwSubAgent />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/rates",
          element: <UwCommRates />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/banks",
          element: <GlBank />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/integration",
          element: <GlIntegration />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/bankac",
          element: <GlBankAc />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/config",
          element: <AdConfig />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/coa",
          element: <GlCoa />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/statement",
          element: <GlStatement />,
          errorElement: <DefaultErrorPage />,
        },

        {
          path: "/planning",
          element: <GlPlanList />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/planning/:id",
          element: <GlPlanSingle />,
          errorElement: <DefaultErrorPage />,
        },

        {
          path: "/box",
          element: <UwPivotTable />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/todo",
          element: <Todo />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/results",
          element: <SearchResults />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/entity/:docid",
          element: <AllEntity key={window.location.pathname} />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/central/:entity_docid",
          element: <AllEntityCentral />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/medrev",
          element: <UwMedicalReview />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/medreq",
          element: <UwMedicalRequest />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/medical/:medical_docid",
          element: <UwMedicalSingle />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/uwnew/:doc_type/:docid",
          element: <UwPolicyNew />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/vehicleImport",
          element: <UwVehicleImport />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/riskImport",
          element: <UwFireImport />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/cmhome",
          element: <CmHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/cm/:docid",
          element: <CmClaim />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/ar",
          element: <ArHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/arreg",
          element: <UwRegister />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/arHome",
          element: <ArReceiptHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/receipt/:docid",
          element: <ArReceipt />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/apHome",
          element: <ApPaymentHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/payment/:docid",
          element: <ApPayment />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/entityImport",
          element: <EntityImport />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/clients",
          element: <AllEntityHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/profile",
          element: <AdProfile />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/vset",
          element: <AllValueSet />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/repdef",
          element: <AllReportGroup />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/reports/:group",
          element: <AllReportRun />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/balances",
          element: <GlPeriodBalance />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/location",
          element: <AllLocation />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/packages",
          element: <AllPlans />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/claimbox",
          element: <FacilityClaimInbox />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/cfm",
          element: <FacilityClaimsList />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/cfm/:claim_docid",
          element: <FacilityClaim />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/crp",
          element: <FacilityReports />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/pmt",
          element: <FacilityPayments />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/contributions",
          element: <GlContributionHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/contribution/:docid",
          element: <GlContribution key={window.location.pathname} />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/treaties",
          element: <RiTreaty />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/ribatches",
          element: <RiBatches />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/ri/:docid",
          element: <RiBatch />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/test",
          element: <TestPage />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/searchResults",
          element: <SearchResults />,
          errorElement: <DefaultErrorPage />,
        },
        // BUSINESS DEVELOPMENT
        {
          path: "/bd/:docType",
          element: <BdHomeList />,
          errorElement: <DefaultErrorPage />,
        },
        // ADMINISTRATION
        {
          path: "/jobs",
          element: <AgendaJobs />,
          errorElement: <DefaultErrorPage />,
        },
        // ASSET MANAGEMENT
        {
          path: "/funds",
          element: <AmFundHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/fund/:docid",
          element: <AmFund />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/fmon",
          element: <AmMonitorHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/fmon/:docid",
          element: <AmMonitor />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/benchmarks",
          element: <AmBenchmarkHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/securities",
          element: <AmSecurityHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/amsec/:docid",
          element: <AmSecurity />,
          errorElement: <DefaultErrorPage />,
        },

        {
          path: "/amsubs",
          element: <AmSubHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/amsubs/:docid",
          element: <AmSub />,
          errorElement: <DefaultErrorPage />,
        },

        {
          path: "/trade",
          element: <AmTradeHome />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/trade/:docid",
          element: <AmTrade />,
          errorElement: <DefaultErrorPage />,
        },

        // HCM
        {
          path: "/hrjob",
          element: <HrJob />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/hrabs",
          element: <HrAbsence />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/hrpos",
          element: <HrPosition />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/people",
          element: <HrPeople />,
          errorElement: <DefaultErrorPage />,
        },

        {
          path: "/riskmap",
          element: <UwRiskMap />,
          errorElement: <DefaultErrorPage />,
        },

        // TICKETS
        {
          path: "/tktcatg",
          element: <TicketCategory />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/tktalt",
          element: <TicketAlerts />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/tickets",
          element: <Tickets />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/tickets/:docid",
          element: <Ticket />,
          errorElement: <DefaultErrorPage />,
        },
        // BIDS
        {
          path: "/bids",
          element: <AdAuctions />,
          errorElement: <DefaultErrorPage />,
        },
        {
          path: "/bids/:docid",
          element: <AdAuction />,
          errorElement: <DefaultErrorPage />,
        },

        // DOCUMENT SCAN
        {
          path: "/scan",
          element: <AdScan />,
          errorElement: <DefaultErrorPage />,
        },
        // CHAT BOT
        {
          path: "/bot",
          element: <BotChat />,
          errorElement: <DefaultErrorPage />,
        },
      ],
    },
    // Catch-all route for 404
    {
      path: "*",
      element: <NotFoundPage />,
    },
  ]);

  return (
    <div className={`theme-${currentTheme}`}>
      <div className="entire-doc">
        <div className="main-container">
          <ToastContainer position="top-center" style={{ marginTop: "100px" }} />
          <RouterProvider router={router} />
        </div>
      </div>
    </div>
  );
}


const DefaultErrorPage = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h1 style={{ marginBottom: "20px" }}>Oops! | page not found.</h1>
      <p>
        We apologize for the inconvenience.{' '}
        <Link href="/" >
          Click here
        </Link>{' '}
        to go back home.
      </p>
    </div>
  );
};


export default App;
